<script>
  import { domainName, record, lookupFound } from '../stores.js';
  import DMARCResultRaw from './dmarcResultRaw.svelte';
  import DMARCResultTags from './dmarcResultTags.svelte';
  import DMARCModifyForm from './dmarcForm.svelte';
  import DMARCResultNotFound from './dmarcResultNotFound.svelte';
  // import DMARCShare from './dmarcShare.svelte';
  //import Sidebar from '../Sidebar.svelte';

  let modifyDmarc = false;
</script>

<section class="tool-banner tool-banner-dmarc mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12 m-auto banner-text">
          <h2>View DMARC Record</h2>
          <p>Prevent unauthorized email using your domain from being delivered.</p>
          <button on:click={() => window.location.reload()} class ="refresh-page" title="Look Up or Generate DMARC Record">Search New Domain</button><i class="fa-solid fa-arrows-rotate"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <div class="found">
              {#if $lookupFound}
                <ul class="result-heading record-found">
                  <li><h3>DMARC Record Found: {$domainName}</h3></li>
                </ul>
              {:else}
                <ul class="result-heading no-record-found">
                  <li><h3>No DMARC Record Found: {$domainName}</h3></li>
                </ul>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="record record-dmarc">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        {#if $lookupFound}
          <DMARCResultRaw />
          <DMARCResultTags />

          <div class="btn-wrap">
            <button on:click|preventDefault={() => modifyDmarc = true} disabled={modifyDmarc} class="btn btn-1 btn-lg" id="modify-dmarc">Modify DMARC Record</button>
          </div>

          {#if modifyDmarc}
            <div class="record-box dmarc-modify-form">
              <div id="headingRaw" class="box-label">
                <h5>Modify DMARC Record</h5>
                <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseModify" aria-expanded="true" aria-controls="collapseModify" aria-label="Close"></button>
              </div>
              <div id="collapseModify" class="box-detail" aria-labelledby="headingRaw">
                <DMARCModifyForm />
              </div>
            </div>
          {/if}
          {:else}
            <DMARCResultNotFound />
        {/if}
      </div>


    </div>
  </div>
</section>

<style>

</style>
